<template>
  <div class="wrapper text-left">
    <GoBackButton />
    <div
      v-if="offer"
      class="row text-left m-0"
    >
      <div class="col-sm-12 col-xl-8 pr-2 bg-card">
        <div>
          <div class="apply">
            {{ $t('pages.offer-apply.title') }}
          </div>
          <h1 class="mb-4">
            {{ offer.titleTitle }}
          </h1>
          <div v-if="isCvFilledData">
            <div
              v-if="myCv"
              class="mb-4"
            >
              <div>{{ $t('pages.offer-apply.current-document') }}</div>
              <div
                class="document-download"
                @click="showCV"
              >
                <font-awesome-icon
                  icon="download"
                />
                {{ myCv.document }}
              </div>
              <div>
                <font-awesome-icon
                  icon="clock"
                />
                {{ $t('pages.offer-apply.current-document', { date: myCv.created_at}) }}
              </div>
            </div>
            <h2>{{ $t('pages.offer-apply.presentation-text.text') }}</h2>
            <b-form-group>
              <b-form-radio
                id="no-letter"
                v-model="$v.form.selected.$model"
                name="some-radios"
                value="no-letter"
                :state="$v.form.selected.$dirty ? !$v.form.selected.$error : null"
              >
                {{ $t('pages.offer-apply.presentation-text.dont-include') }}
              </b-form-radio>
              <b-form-radio
                v-model="$v.form.selected.$model"
                aria-describedby="no-letter"
                :state="$v.form.selected.$dirty ? !$v.form.selected.$error : null"
                name="some-radios"
                value="with-letter"
              >
                {{ $t('pages.offer-apply.presentation-text.include') }}
              </b-form-radio>
              <b-form-textarea
                v-if="form.selected === 'with-letter'"
                id="textarea"
                v-model="$v.form.letter.$model"
                :state="$v.form.letter.$dirty ? !$v.form.letter.$error : null"
                class="mb-3"
                :placeholder="$t('inputs.comment.placeholder', 'Enter something...')"
                rows="3"
              />
            </b-form-group>

            <div>
              <h2>{{ $t('pages.offer-apply.answer-questions') }}</h2>
              <KillerAnswers
                ref="killerAnswers"
                :offer-id="offer.id"
                @updateKillerAnswers="updateKillerAnswers"
              />
            </div>

            <b-overlay
              :show="btnBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <b-button
                variant="info"
                class="apply-button"
                @click="validate"
              >
                {{ $t('pages.offer-apply.confirm') }}
              </b-button>
            </b-overlay>
          </div>
          <div v-if="!isCvFilledData">
            <b-alert
              variant="danger"
              show
            >
              <div class="text-center">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  class="danger-icon mx-auto my-3"
                />
                <div>
                  {{ $t('pages.offer-apply.cv-warning.title') }}
                </div>
                <div>
                  {{ $t('pages.offer-apply.cv-warning.subtitle') }}
                </div>
                <b-button
                  variant="success"
                  class="my-3"
                  @click="$router.push({ name: 'my-cv' })"
                >
                  {{ $t('pages.offer-apply.cv-warning.button') }}
                </b-button>
              </div>
            </b-alert>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xl-4 pl-2">
        <div class="bg-card">
          <strong>{{ $t('pages.offer-apply.sidebar.title') }}</strong>
          <ul class="offer-data">
            <li v-if="offer && offer.user && offer.user.company">
              <strong>{{ $t('pages.offer-apply.sidebar.company') }}</strong>
              <div>{{ offer.user.company.title }}</div>
            </li>
            <li>
              <strong>{{ $t('pages.offer-apply.sidebar.place') }}</strong>
              <div>
                {{ offer.locationProvince }},
                {{ offer.locationMunicipality }}
                ({{ offer.locationCountry }})
              </div>
            </li>
            <li>
              <strong>{{ $t('pages.offer-apply.sidebar.salary') }}</strong>
              <div>
                <span v-if="offer.salaryShowAs == 'from-to'">
                  {{ $t('generic.salary-from-to', { min: offer.salaryMinimum, max: offer.salaryMaximum, type: offer.salaryType }) }}
                </span>
                <span v-else-if="offer.salaryShowAs == 'more-than'">
                  {{ $t('generic.salary-more-than.placeholder') }} {{ $t('generic.salary-more-than', { min: offer.salaryMinimum, type: offer.salaryType}) }}
                </span>
                <span v-else-if="offer.salaryShowAs == 'dont-show'">
                  {{ $t('generic.salary-dont-show') }}
                </span>
              </div>
            </li>
            <li>
              <strong>{{ $t('pages.offer-apply.sidebar.publish-date') }}</strong>
              <div>{{ offer.created_at.split(' ')[0] }}</div>
            </li>
            <li>
              <strong>{{ $t('pages.offer-apply.sidebar.min-exp') }}</strong>
              <div>{{ $t(`data.experience.${offer.requirementsMinExp}`, offer.requirementsMinExp) }}</div>
            </li>
            <li>
              <strong>{{ $t('pages.offer-apply.sidebar.contract-type') }}</strong>
              <div>{{ $t(`data.contractTypes.${offer.contractType}`, offer.contractType) }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import { required, requiredIf } from "vuelidate/lib/validators";
import KillerAnswers from "@/components/jobs/blocks/KillerAnswers.vue";

export default {
  components: {
    GoBackButton,
    KillerAnswers
  },
  data() {
    return {
      offer: null,
      form: {
        selected: null,
        letter: ''
      },
      isCvFilledData: false,
      myCv: null,
      killerAnswers: [],
      btnBusy: false
    }
  },
  validations: {
    form: {
      selected: { required },
      letter: { required: requiredIf(function () {
          return this.form.selected.value === "with-letter";
        }) }
    }
  },
  mounted() {
    this.offer = this.$route.params.offer;
    this.isCvFilled(); //Is mandatory fields of User CV filled
  },
  methods: {
    validate() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.offer-apply.alert.correct-errors', 'Please correct the errors in the form'));
        return false;
      } else {
        if(this.$refs.killerAnswers.validateKillerAnswers()) {
          this.submit();
          return true;
        }
        this.$toastNotification('danger', '', this.$t('pages.offer-apply.alert.answer-killer-questions', 'Please answer some killer questions'));
        return false;
      }
    },
    submit() {
      this.save();
    },
    save() {
      this.btnBusy = true;
      this.form.offer_id = this.offer.id;

      this.axios
        .post('/offerApply', this.form)
        .then( async (response) => {
          if (response.data) {
            await this.postKillerAnswers(response.data.id);
          } else {
            this.$router.push({ name: 'applied-offers', params: { notif: 'apply_failure' } });
          }

          this.btnBusy = false;
        })
    },
    isCvFilled() {
      this.axios.get('/cv/mandatoryFilled')
        .then(response => {
          this.isCvFilledData = response.data;
          this.getMyCv();
        })
        .catch();
    },
    getMyCv() {
      this.axios.get('/cv/')
        .then( response => {
          this.myCv = response.data;
        })
        .catch();
    },
    showCV() {
      window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv_v2/' + this.myCv.document);
    },
    updateKillerAnswers(answers) {
      this.killerAnswers = answers;
    },
    postKillerAnswers(offerApplyId) {
      this.axios.post('/offer/killerQuestionsCandidate/' + offerApplyId, this.killerAnswers)
        .then( () => {
          this.$router.push({ name: 'applied-offers', params: { notif: 'apply_success' } });
        })
        .catch();
    }
  }
}
</script>

<style lang="scss" scoped>
  ul.offer-data {
    padding-left: 15px;
    font-size: 0.9rem;

    li {
      padding: 0 0 10px;

      strong {
        font-weight: bold;
      }
    }
  }

  .apply {
    color: #999;
    font-weight: 600;
  }
</style>
